// extracted by mini-css-extract-plugin
export var acceptButton = "XpaModal-module__acceptButton___XoZmF";
export var bottomButtons = "XpaModal-module__bottomButtons___Y2wmg";
export var bulletItem = "XpaModal-module__bulletItem___EHvFi";
export var bulletLink = "XpaModal-module__bulletLink___LXk9f";
export var bulletList = "XpaModal-module__bulletList___2pTHN";
export var buttonContainer = "XpaModal-module__buttonContainer___pY3XJ";
export var checkbox = "XpaModal-module__checkbox___eSmK8";
export var checkboxLabel = "XpaModal-module__checkboxLabel___g-o-C";
export var checkboxText = "XpaModal-module__checkboxText___7MC-R";
export var closeButton = "XpaModal-module__closeButton___Magf7";
export var datePicker = "XpaModal-module__datePicker___a9ehe";
export var datePickerContainer = "XpaModal-module__datePickerContainer___0iWvz";
export var description = "XpaModal-module__description___AHfSy";
export var disabledLabel = "XpaModal-module__disabledLabel___6V5wQ";
export var errorMessage = "XpaModal-module__errorMessage___TIOb-";
export var errorMessageContainer = "XpaModal-module__errorMessageContainer___K8DeI";
export var exitButton = "XpaModal-module__exitButton___kfHkR";
export var exitSaveButton = "XpaModal-module__exitSaveButton___nv3DR";
export var gameTitle = "XpaModal-module__gameTitle___WKNHh";
export var leftSection = "XpaModal-module__leftSection___m2XSV";
export var loadingOverlay = "XpaModal-module__loadingOverlay___wqngB";
export var loadingText = "XpaModal-module__loadingText___NFMWv";
export var modalBody = "XpaModal-module__modalBody___+oJ+O";
export var modalContainer = "XpaModal-module__modalContainer___Ir3Mc";
export var modalHeader = "XpaModal-module__modalHeader___b3gsS";
export var modalTitle = "XpaModal-module__modalTitle___v2R4m";
export var optInContainer = "XpaModal-module__optInContainer___M5qy0";
export var readOnlyDateContainer = "XpaModal-module__readOnlyDateContainer___U5BkO";
export var readOnlyDatePicker = "XpaModal-module__readOnlyDatePicker___tO0vv";
export var readOnlyDatePickerContainer = "XpaModal-module__readOnlyDatePickerContainer___bxDVe";
export var readOnlyTitleMargin = "XpaModal-module__readOnlyTitleMargin___IQVPp";
export var requiredAsterisk = "XpaModal-module__requiredAsterisk___-sc2S";
export var requirementsContainer = "XpaModal-module__requirementsContainer___056pZ";
export var requirementsDescription = "XpaModal-module__requirementsDescription___UjhHD";
export var rightSection = "XpaModal-module__rightSection___buzTj";
export var saveOptInButton = "XpaModal-module__saveOptInButton___cZabq";
export var sectionTitle = "XpaModal-module__sectionTitle___3d2Rl";
export var validMessage = "XpaModal-module__validMessage___BDyjn";
export var validateButton = "XpaModal-module__validateButton___IvKnm";
export var validateContainer = "XpaModal-module__validateContainer___Rrcwc";
export var validationMessage = "XpaModal-module__validationMessage___o8iir";